export default [
  {
    path: '/webchat/main',
    name: 'webchat_main',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/webchat/webchat_main')
  },
  {
    path: '/chatbot/preview',
    name: 'chatbot_preview',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/menus/chatbot/chatbot_preview')
  },
  {
    path: '/webchat/test',
    name: 'webchat_test',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/webchat/webchat_test')
  }
]



// WEBPACK FOOTER //
// ./src/router/subRoutes/webchatRouter.js